import * as React from 'react'
import { Intent } from '@blueprintjs/core'
import { ExpressListPriceInput } from './ExpressListPriceInput'
import { EbayForm } from './types'
import { EbaySpecifics } from '../products_v5/components/JoinedForm/EbayCard/EbaySpecificsContainer'
import { Requirements } from '../products_v5/components/JoinedForm/types'
import { renderErrorButPreferRequired } from '../products_v5/components/JoinedForm/Helpers'
import { safeIsEmpty } from './utils'

interface Props {
  ebayForm: EbayForm
  ebayRequirements: Requirements
  submitFieldErrors: Record<string, string[]> | null
  loadingRefreshSpecifics: boolean
  onPriceChange: (value: string) => void
  onFormChange: ({ name, value }: { name: string; value: any }) => void
  onSpecificChange: (value: string, specificIndex: number) => void
  onProductDetailChange: ({ name, value }: { name: string; value: any }) => void
  onRefreshSpecifics: () => void
}

export const ExpressListEbayCard: React.FC<Props> = ({
  ebayForm,
  ebayRequirements,
  submitFieldErrors,
  loadingRefreshSpecifics,
  onPriceChange,
  onFormChange,
  onSpecificChange,
  onProductDetailChange,
  onRefreshSpecifics
}) => {
  const priceLabel = ebayForm.listingType === 'Chinese' ? 'Starting price' : 'Price'

  return (
    <div data-testid="card-ebay">
      <h1>EBAY</h1>

      <div className="bp5-form-group">
        <label className="bp5-label" htmlFor="ebay-price-input">
          {priceLabel}
          {safeIsEmpty(ebayForm.startingPrice) && <span className="bp5-text-muted"> *</span>}
        </label>
        <div className="bp5-form-content">
          <ExpressListPriceInput
            leftIcon="dollar"
            fill
            intent={submitFieldErrors?.ebayListingStartingPrice ? Intent.DANGER : null}
            id="ebay-price-input"
            value={ebayForm.startingPrice}
            onValueChange={onPriceChange}
          />
          {renderErrorButPreferRequired(submitFieldErrors?.ebayListingStartingPrice)}
        </div>
      </div>

      {ebayForm.categoryMarketCategory?.id && (
        <div className="express-list-ebay-specifics">
          <EbaySpecifics
            form={ebayForm}
            requirements={ebayRequirements}
            errors={submitFieldErrors || {}}
            onFormChange={onFormChange}
            onSpecificChange={onSpecificChange}
            onProductDetailChange={onProductDetailChange}
            onRefreshSpecifics={onRefreshSpecifics}
            loadingRefreshSpecifics={loadingRefreshSpecifics}
            sectionOpen
          />
        </div>
      )}
    </div>
  )
}
